import get from 'lodash.get';

export const selectViewPagingStats = (state, props) => get(state, props.viewName);
